define(function () {
	var IpsModelCollection = require('civicsBase/ipsModelCollection');

	return IpsModelCollection.extend({
		urlRoot:'https://geocode.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest?',
		url: function () {
			var url = this.urlRoot;
			if (url.indexOf('?') < 0) {
				url += '?';
			}
			//append any additional parameters that need to be passed to the server, if there are any.
			if (this.parameters) {
				//object.entries takes an object and returns an array of [key,value] arrays
				//reduce loops through an array and appends whats returned to the out variable then returns the final value
				url += Object.entries(this.parameters).reduce((out, current) => out + '&' + current[0] + '=' + current[1], '');
			}
			return url;
		},
		parameters: {},
		parse: function (data) {

		},
		//end backbone functions//
 
		//hopefully temporary code to remove the __type variable and fees object in lookup.
		removeProp: function (obj, propToDelete) {
			for (var property in obj) {
				if (property === propToDelete) {
					delete obj[property];
				} else if (typeof obj[property] == 'object') {
					let objectToCheck = obj[property];
					delete obj.property;
					let newJsonData = this.removeProp(obj[property], propToDelete);
					obj[property] = newJsonData;
				}
			}
			return obj;
		},
	});
});